// extracted by mini-css-extract-plugin
module.exports = {"col":"styles_col__30D8D","separator":"styles_separator__bnLL_"};